<template>

    <div class="container remove-padding-margin">
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"
                  v-if="isClickedloader === true"></span>
        </div>
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="back">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                        <div class="remove-margin">Login Nomor WA</div>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="font-16 color-0000 line-height-25 letter-space-002">
                        Nomor Whatsapp digunakan untuk login Smartlink Owner saat ini adalah : <br>
                    </div>
                    <div class="font-18 color-0000 font-weight-600 line-height-28 letter-space-002 mar-top-16 mar-bottom-24">+{{this.telp_owner}}</div>
                        <div>
                            <button type="button" class="btn btn-outline-primary btn-long" data-toggle="modal" data-target="#modaleditnumber">Ubah Nomor WA</button>
                        </div>
                </div>
            </div>
            <div class="modal fade" id="modaleditnumber" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Ubah Nomor WA</h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <form class="remove-padding" action="">
                                <label for="inputNomor" class="text-login-wa require">Nomor Whatsapp yang baru</label>
                                <div class="input-group remove-padding">
	                                <vue-country-code
		                                @onSelect="onSelect" :preferredCountries="['id', 'my', 'bn']">
	                                </vue-country-code>
                                    <input type="tel" class="form-control inputs" id="inputNomor" placeholder="81757875431"
                                           v-on:keyup="nomorWaOnkeyup" v-model="telp_owner_new">
                                </div>
	                            <ErrorMessage class="error" label="Nomor Whatsapp" :validation="$v.telp_owner_new"></ErrorMessage>
                            </form>
                            <div class="mar-top-16">Kami akan mengirim kode OTP ke <b>nomor WA lama</b> dan ke <b>nomor WA baru</b> untuk verifikasi. </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-outline-primary btn-long" @click="submit" id="btnnewnumber">Berikutnya</button>
                        </div>
                    </div>
                </div>
            </div>
	        <vue-recaptcha
		        ref="recaptcha"
		        @verify="onCaptchaVerified"
		        @expired="onCaptchaExpired"
		        size="invisible"
		        sitekey="6Lc_X9QZAAAAAI0vmQNzNDQG-rKZ7NOE0O3wq5W9">
	        </vue-recaptcha>
        </main>
    </div>
</template>

<script>
	import VueRecaptcha from "vue-recaptcha"
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, maxLength, required} from "vuelidate/lib/validators";

    export default {
        name: "LoginOwnerWA",
	    components: { 'vue-recaptcha': VueRecaptcha, ErrorMessage },
        data(){
          return{
              telp_owner:'',
              telp_owner_new:'',
              isClickedloader:false,
              dataError:0,
	          telpCode: "",
              requestHeaders: {
                  headers: {
                      'Authorization': 'Bearer ' + localStorage.getItem('token'),
                  }
              },
          }
        },
	    validations: {
		    telp_owner_new: {
		    	required,
			    minLength: minLength(8),
			    maxLength: maxLength(12),
		    }
	    },
        mounted(){
        	this.getdetailowner();
	
	        let recaptchaScript = document.createElement('script')
	        recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit')
	        document.head.appendChild(recaptchaScript)
	
	        $('body').on('DOMSubtreeModified', '.grecaptcha-badge', function(){
		        $(".grecaptcha-badge").hide()
	        });
        },
        methods: {
	        onSelect({name, iso2, dialCode}) {
		        this.telpCode=dialCode
	        },
            back() {
                this.$router.push('/detailakunowner')
            },
	        submit() {
            	if (this.$v.telp_owner_new.$invalid) {
		            this.$v.telp_owner_new.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
            this.getotplama("null")
		        // this.$refs.recaptcha.execute();
	        },
	        onCaptchaVerified: function (recaptchaToken) {
		        this.getotplama(recaptchaToken)
		        const self = this;
		        self.$refs.recaptcha.reset();
	        },
	        onCaptchaExpired: function () {
		        this.$refs.recaptcha.reset();
	        },

            nomorlama(){
                this.$router.push('/nomorlama')
            },

            checkvalidate(){
            	return
                var staffname = this.telp_owner_new;
                var lenPass = staffname.length;
                if (lenPass >= 8) {
                    $('#btnnewnumber').prop('disabled', false);
                } else {
                    $('#btnnewnumber').prop('disabled', true);
                }
            },

            nomorWaOnkeyup(event) {
                var phoneField = event.target.value;
                var frstCar = phoneField.substring(0, 1);
                var firstTel = phoneField.substring(1, 13);
                var secCar = phoneField.substring(0, 2);
                var secTel = phoneField.substring(2, 13);
                var thrdcar = phoneField.substring(0, 12);
                var output


                if (frstCar == 0) {
                    output = firstTel
                } else if (secCar == this.telpCode) {
                    output = secTel
                } else {
                    output = thrdcar
                }
                var number =output.replace(/[^0-9]+/, '');

                var charLenght = number.length;
                if (charLenght >= 8 && charLenght <= 12) {
                    // $('#buttonSendOtp').prop('disabled', false);
                } else {
                    // $('#buttonSendOtp').prop('disabled', true);
                }
                this.telp_owner_new =number;
                this.checkvalidate()
            },

            async getotplama(recaptchaToken){
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                var telpStr = this.telp_owner
                var replaceTelp = telpStr.replace(/-/g, "");
                var replaceSpace = replaceTelp.replace(/\s/g, "");
                var fixTelp = replaceSpace.replace(/\+/g, "");
                try {
                    const dataOtp = new FormData;
                    dataOtp.append('nomor_wa_lama', fixTelp);
                    dataOtp.append('nomor_wa_baru', this.telpCode + this.telp_owner_new);
	                dataOtp.append('token_captcha', recaptchaToken);
                    const res = await this.$axios.post(this.$baseurl + '/masterData/owner/kirim_otp_nomor_lama_owner', dataOtp,this.requestHeaders)
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
	                    localStorage.setItem("telp", this.telp_owner);
                        localStorage.setItem("telpBaru",'62' + this.telp_owner_new);
                        this.telp_owner_new=''
                        this.dataError = 0;
                        this.nomorlama()
	                    $("#modaleditnumber").modal("hide")
                    }else{
                    	this.$toast.error(res.data.msg)
                    }

                }catch (e) {
                	this.$catch_error_response(e)
	
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false;
	                
	                this.isClicked = false
	                $('#textBtnpersonal').show()
	                $('#btnpersonal').prop('disabled', false);
                }
            },
	        async getdetailowner() {
		        $('#loadingPage').addClass('overlayLoading');
		        this.isClickedloader = true
		        try {
			        const res = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner',  this.requestHeaders);
			        this.owner = res.data.data
			        if(res.data.status===true){
				        $('#loadingPage').removeClass('overlayLoading');
				        this.isClickedloader = false;
				        // $('#loadingPage').hide();
				        var dataowner = res.data.data
				        this.telp_owner = dataowner.telp
			        }else{
				        $('#loadingPage').removeClass('overlayLoading');
				        // $('#loadingPage').hide();
				        this.isClickedloader = false;
			        }
		        } catch (e) {
		        	this.$catch_error_response(e)
			
			        $('#loadingPage').removeClass('overlayLoading');
		        }
	        },
        }
    }
</script>

<style scoped>

</style>